import React, { createContext, useContext, useRef, useState } from 'react';
import { hourglass } from 'ldrs';
hourglass.register();

const LoadingContext = createContext({
  pendingCount: 0,
  start: () => Symbol('loader'),
  stop: () => {},
  add: () => {},
  remove: () => {},
});

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const keysRef = useRef(new Set());

  const add = (key) => {
    if (!keysRef.current.has(key)) {
      keysRef.current.add(key);
      setPendingCount(keysRef.current.size);
    }
  };

  const remove = (key) => {
    if (keysRef.current.has(key)) {
      keysRef.current.delete(key);
      setPendingCount(keysRef.current.size);
    }
  };

  const start = (key) => {
    const k = key ?? Symbol('loader');
    add(k);
    return k;
  };

  const stop = (key) => remove(key);

  return (
    <LoadingContext.Provider value={{ pendingCount, start, stop, add, remove }}>
      {pendingCount > 0 && (
        <div className="loading-overlay">
          <img src="/assets/images/flyspa-logo.svg" alt="Flyspa Logo" />
          <l-hourglass size="40" bg-opacity="0.1" speed="1.75" color="#b3bec5" />
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
};
